import { getUrl } from "./urls";
import { getAccessToken, getCompanyId } from "./utils";
import axios from "axios";
import store from "../store";
import _ from "lodash";
import { toast } from "react-toastify";

export const FETCH_FILTER_LIST = "FETCH_FILTER_LIST";
export const UPDATE_FILTER_SHOW_STATUS = "UPDATE_FILTER_SHOW_STATUS";
export const UPDATE_DEFAULT_SHOW_STATUS = "UPDATE_DEFAULT_SHOW_STATUS";
export const UPDATE_SETTING_UPDATED = "UPDATE_SETTING_UPDATED";
export const UPDATE_SHOW_ALL = "UPDATE_SHOW_ALL";
export const SAVE_FILTER_SETTINGS = "SAVE_FILTER_SETTINGS";

export const updateDefault = (payload) => {
    return {
        type: UPDATE_DEFAULT_SHOW_STATUS,
        payload,
    };
};

export const updateShowALL = (payload) => {
    return {
        type: UPDATE_SHOW_ALL,
        payload,
    };
};

export const updateShowStatus = (payload) => {
    return {
        type: UPDATE_FILTER_SHOW_STATUS,
        payload,
    };
};

export const updateSettingUpdated = (payload) => {
    return {
        type: UPDATE_SETTING_UPDATED,
        payload,
    };
};
export const fetchFiltersList = () => {
    let QueryfilterState = store.getState().dataUsageReducer;
    // console.log("firstcreateQueryList", QueryfilterState);

    const req = axios
        .get(`${getUrl("filter_service")}/filter/list?company_id=${getCompanyId()}&access-token=${getAccessToken()}`, {
            headers: {
                "Content-type": " application/json",
            },
        })
        .then((res) => {
            return { data: res.data.data, QueryfilterState: QueryfilterState.createQueryList };
        })
        .catch((err) => {
            console.log(err);
            return err;
        });

    return {
        type: FETCH_FILTER_LIST,
        payload: req,
    };
};

export const saveFilter = () => {
    let filterState = store.getState().filterSettingReducer;
    let data = { company_id: getCompanyId(), filters: getFilterSaveData(filterState) };

    const req = axios
        .patch(`${getUrl("filter_service")}/filter/update?access-token=${getAccessToken()}`, data, {
            headers: {
                "Content-type": " application/json",
            },
        })
        .then((res) => {
            toast.success("Filters updated successfully");

            return res.data.data;
        })
        .catch((err) => {
            console.log(err);
            if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            else toast.error("Some Error Occured.");
            return err;
        });

    return {
        type: SAVE_FILTER_SETTINGS,
        payload: req,
    };
};

const getFilterSaveData = (filterState) => {
    const {
        filterSettingsUpdated: updated,
        topic,
        platform,
        location,
        language,
        publication,
        twitter_trends_countries,
        trending_videos_counties,
    } = filterState;

    let data = {};
    if (updated.topic.length > 0) {
        data.keywords = {
            section_name: 6,
            items: getFilterItemsToUpdate(topic, updated.topic),
        };
    }
    if (updated.platform.length > 0) {
        data.platforms = {
            section_name: 6,
            items: getFilterItemsToUpdate(platform, updated.platform),
        };
    }
    if (updated.location.length > 0) {
        data.locations = {
            section_name: 6,
            items: getFilterItemsToUpdate(location, updated.location),
        };
    }
    if (updated.language.length > 0) {
        data.languages = {
            section_name: 6,
            items: getFilterItemsToUpdate(language, updated.language),
        };
    }
    if (updated.publication.length > 0) {
        data.publications = {
            section_name: 3,
            items: getFilterItemsToUpdate(publication, updated.publication),
        };
    }
    if (updated.twitter_trends_countries.length > 0) {
        data.twitter_trends_countries = {
            section_name: 10,
            items: getFilterItemsToUpdate(twitter_trends_countries, updated.twitter_trends_countries),
        };
    }

    if (updated.trending_videos_counties.length > 0) {
        data.trending_videos_counties = {
            section_name: 12,
            items: getFilterItemsToUpdate(trending_videos_counties, updated.trending_videos_counties),
        };
    }
    return data;
};

const getFilterItemsToUpdate = (filter, update) => {
    let data = filter;
    update = _.uniq(update);
    if (update[0] !== "all") {
        data = filter.filter((f) => update.includes(f.entity_id));
    }

    return data.map((d) => {
        return { id: d.entity_id, is_active: d.is_active, is_default: d.is_default };
    });
};

export const saveFilterTrends = ({ countries, modal }) => {
    let filterState = store.getState().filterSettingReducer;

    let data = { company_id: getCompanyId(), filters: getFilterSaveDataForTrends(filterState, countries, modal) };

    const req = axios
        .patch(`${getUrl("filter_service")}/filter/update?access-token=${getAccessToken()}`, data, {
            headers: {
                "Content-type": " application/json",
            },
        })
        .then((res) => {
            toast.success("Filters updated successfully");

            return res.data.data;
        })
        .catch((err) => {
            console.log(err);
            if (err.response.data && err.response.data.message) toast.error(err.response.data.message);
            else toast.error("Some Error Occured.");
            return err;
        });

    return {
        type: SAVE_FILTER_SETTINGS,
        payload: req,
    };
};

const getFilterSaveDataForTrends = (filterState, countries, modal) => {
    const { filterSettingsUpdated: updated } = filterState;

    let data = {};

    if (updated.twitter_trends_countries.length > 0 && modal === "twitter") {
        data.twitter_trends_countries = {
            section_name: 10,
            items: getFilterItemsToUpdateTrends(countries, updated.twitter_trends_countries, filterState.twitter_trends_countries),
        };
    }

    if (updated.trending_videos_counties.length > 0 && modal === "youtube") {
        data.trending_videos_counties = {
            section_name: 12,
            items: getFilterItemsToUpdateTrends(countries, updated.trending_videos_counties, filterState.trending_videos_counties),
        };
    }

    return data;
};

const getFilterItemsToUpdateTrends = (filter, update, filtereducercountries) => {
    //console.log("filterupdate",filter,update)
    let data = filter;

    update = _.uniq(update);
    let filterCountries = [];
    if (update[0] != "all") {
        data = filter.filter((f) => update.includes(f.entity_id));
    }

    let defaultData = filter.find((defaultID) => {
        return defaultID.is_default === 1;
    });

    if (update[0] != "all") {
        filtereducercountries.forEach((updatedList) => {
            if (!update.includes(updatedList.entity_id) && updatedList.is_default === 1 && updatedList.entity_id !== defaultData.entity_id) {
                filterCountries.push({ id: updatedList.entity_id, is_active: updatedList.is_active, is_default: 0 });
            }
        });
    }

    let d = data
        .map((d) => {
            return { id: d.entity_id, is_active: d.is_active, is_default: d.is_default };
        })
        .concat(filterCountries);
    return d;
};

export const setFilterListFetchedStatus = () => {
    return {
        type: "SET_FILTER_LIST_FETCHED_STATUS",
    };
};
